import store from '@/store/index.js';
import { EventBus } from '@/event-bus';
import draftMixins from '@/components/mixins/Drafts.vue'
export default {
    mixins: [draftMixins],
    methods: {
        async buildEvent(post){
            console.log("post",post)
            if (!post._bots || !post._bots.length || !post._bots[0].page) {
                return false
            }
            const page = post._bots[0].page
        
        
            let draft = post.page.length && post.page[0].draft ? JSON.parse(post.page[0].draft) : post.draft ? post.draft.data : undefined
            if (!post.page[0]) {
                console.log("!post.page[0]", post)
            }
            console.log('clemcle3', this.allPages, page)
            const event =  {
                "id": post.id + page.id,
                "date": post.page && post.page.length ? post.page[0].posted_date || post.page[0].scheduled_date : post.scheduled_date || post.published_at,
                "formatedDate": null,
                "image": post.enclosure,
                "status": null,
                "type": null,
                "page": {
                    id: page.id,
                    avatar: this.allPages[page.id].avatar,
                    network: this.allPages[page.id].network,
                },
                "content": post.title,
                "draft": draft,
                "originalPost": post
            }

            //status
            if (!event.status) {



                if (post.page && post.page.length) {

                    if (
                        event.originalPost.page[0].affectedTo && 
                        event.originalPost.page[0].affectedTo.optionValidation && 
                        !['null', 'false'].includes(event.originalPost.page[0].affectedTo.optionValidation) &&
                        (!event.originalPost.page[0].wait_validation || event.originalPost.page[0].wait_validation == 'null')

                    ) {
                 
                        if (
                            (event.originalPost.page[0].affectedTo.user && event.originalPost.page[0].affectedTo.user.id == this.currentUser.id) ||
                            (event.originalPost.page[0].affectedTo.users && event.originalPost.page[0].affectedTo.users.length && event.originalPost.page[0].affectedTo.users.some(user => user.id == this.currentUser.id))
                        ) {
                            event.status = 'to_validate'
                        }else{
                            event.status = 'awaiting_approval'
                        }
                    
                       
                    }else{
                        event.status = ['removed', null, 'scheduled', 'posted', 'pending', 'failed', null, 'draft'][post.page[0].status + 1] //+1 pour inclure removed (removed = -1) 
                    }
                   
                } else {
                    event.status = 'standby'
                }
            }

            //type
            if (!event.type) {
                if (post.page && post.page.length) {
                    if(post.page[0].network == "instagram" && (
                        (post.page[0].story || post.page[0].story_multiple) ||
                        (post.page[0].isDraft && post.draft.data.tab && post.draft.data.tab == 'story')
                    )) {
                        event.type = 'story'
                    }else if (post.page[0].carousel && post.page[0].carousel.length) {
                        if (post.page[0].carousel.length > 1) {
                            event.type = 'carousel'
                        }else{
                            if (['png', 'jpeg', 'jpg'].includes(post.page[0].carousel[0].url.split('.').slice(-1)[0]) || ['png', 'jpeg', 'jpg'].includes(post.page[0].carousel[0].ext)) {
                                event.type = 'image'
                            }else{
                                event.type = 'video'
                            }
                        }
                    }
                    else if(post.page[0].document_title){
                        event.type = 'document'
                    }
                    else if(post.page[0].network == "instagram" && post.page[0].typePost == "video") {
                        event.type = 'reel'
                    }
                    else if(post.page[0].typePost == "video") {
                        event.type = 'video'
                    }
                    else if(post.page[0].typePost == "image") {
                        event.type = 'image'
                    }
                    else if(post.page[0].network == "instagram" && post.page[0].carousel && post.page[0].carousel.length) {
                        event.type = 'image'
                    }
                    else if(post.page[0].enclosure) {
                        if (['png', 'jpeg', 'jpg'].includes(post.page[0].enclosure.split('.').slice(-1)[0])) {
                            event.type = 'image'
                        }else{
                            event.type = 'video'
                        }
                    }
                
                }  
        
                // event.type = 'story'
                // ['image','','','','', ''][Math.floor(Math.random() * 6)]
            }
        
            if (!event.date) {
                console.info("BuildEvent error : Pas de date trouvé pour ce post", post)
                return false
            }else{
                const dateInstance = new Date(event.date)
                const options = {day: '2-digit', month: 'short'};
                const options2 = { hour: '2-digit', minute: '2-digit'};
                event.formatedDate = dateInstance.toLocaleDateString('fr-FR', options).replace('.', '') + ` à ${dateInstance.toLocaleTimeString('fr-FR', options2)}`;
            }
            if (!event.status) {
                console.info("BuildEvent error : Pas de status trouvé pour ce post", post)
                return false
            }
        
            if (!event.type) {
                console.info("BuildEvent error : Pas de type trouvé pour ce post", post)
                // return false
            }
        
        
            if (!event.draft) {
                console.info("BuildEvent error : Pas de draft trouvé pour ce post", post)
                return false
            }
        
            return event
        },

        async handlerDeletePost(event = this.events[this.eventIdSelected], all = null) {
            this.eventIdSelected = null
            const isPostsMultipaged = this.isPostsMultipaged(event.originalPost)
            console.log("deletePost isPostsMultipaged",isPostsMultipaged, all)
            if (all == null) {
                if (isPostsMultipaged) {

                    setTimeout(() => {
                        EventBus.$emit("showModal", 
                            "Supression", 
                            "Ce brouillon a été réalisé sur plusieurs pages. Souhaitez-vous suprimer pour l'ensemble des pages ? ", 
                            "Toute les pages", 
                            "Cette page uniquement",  
                            ()=>{
                                this.handlerDeletePost(event, true)
                            },
                            ()=>{
                                this.handlerDeletePost(event, false)
                            },
                        );
                    }, 200);
                    
                    return
                }else{
                    all = false
                }   
            }

            const calendarApi = this.$refs.fullCalendar.getApi();
            
            let eventId, eventInstance;
            if (event.status == 'draft') {
                await this.deleteDraft(event.originalPost.id, isPostsMultipaged && all ? null : event.originalPost._bots[0].page)
                
                if (isPostsMultipaged && all && event.originalPost.draft.data.pages) {
                    event.originalPost.draft.data.pages.forEach(pageId => {
                        eventId = event.originalPost.id + pageId
                        delete this.events[eventId]
                        eventInstance = calendarApi.getEventById(eventId);
                        if(eventInstance) eventInstance.remove();
                    });
                }else{
                    eventId = event.originalPost.id + event.originalPost._bots[0].page.id;
                    delete this.events[eventId]
                    eventInstance = calendarApi.getEventById(eventId);
                    if(eventInstance) eventInstance.remove();
                }


            }else{
                let posts = [event.originalPost]
                if (isPostsMultipaged && all) {
                    posts = event.originalPost.page[0].posts_multipages.map(({_id, page:pageId}) => this.events[_id + pageId].originalPost)
                }
                console.log('posts',posts)

                const results = await Promise.allSettled(
                    posts.map(async (post) => {
                        try {
                            const response = await this.deletePost(post); // Supposé renvoyer une réponse
                            return { post, response: response.body }; // Inclut le post et la réponse
                        } catch (error) {
                            return { post, error }
                        }
                    })
                );
                
               
                
                calendarApi.batchRendering(() => {
                    results.forEach(({status, value}) => {
                        const { response, post, error} = value;
                        if (status == "fulfilled" && response.success && post) {
                            eventId = post._id + post._bots[0].page.id;
                            delete this.events[eventId]

                            eventInstance = calendarApi.getEventById(eventId);
                            eventInstance.remove();

                        }else{
                            console.error(`Échec de la suppression du post avec l'ID ${post._id}:`, response || error);
                        }
                    });
                })

            }
        },   
    },
    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },
    }
  };